import { Analytics } from './analytics';
import { ItemAction } from '../../../item/actions/item_action';

export class ItemAnalytics extends Analytics {
  constructor() {
    super();
    /// バリエーション一覧へリンク押下時
    ItemAction.VARIATION_LINK_EVENT.on((data) => {
      this.run(() => {
        const item = data.analyticsData.items[0];
        const productName = item.getProductName();
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'バリエーション一覧へ',
          items: [this.variationLinkItems(productName)],
          club: {
            server: 'club/pc',
            prop5: 'バリエーション一覧へ',
            products: [this.variationLinkItems(item._catalogItemCode)]
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'MoveVariationList');
      });
    });

    /// 通常商品から定期配送に切替を行った場合
    ItemAction.REGULAR_DELIVERY_EVENT.on((data) => {
      this.run(() => {
        const items = window.analyticsData.items[0];
        const clubProducts = window.analyticsData.club.products[0];
        const soloelProducts = window.analyticsData.soloel.products[0];
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: '定期便商品詳細へ切替',
          events: this.deliveryEvents(['prodView', 'event279', 'event280'], data.isLogin),
          items: [this.regularDeliveryItems(items, '')],
          club: {
            server: 'club/pc',
            prop5: '定期便商品詳細へ切替',
            events: this.deliveryEvents(['prodView'], data.isLogin),
            products: [this.regularDeliveryItems(clubProducts, 'club')]
          },
          soloel: {
            server: 'soloel/pc',
            prop5: '定期配送商品詳細へ切替',
            events: ['prodView', 'event101', 'event102'],
            products: [this.regularDeliveryItems(soloelProducts, 'soloel')]
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'chgToRegularServiceProduct');
      });
    });

    /// 定期配送から通常商品に切替を行った場合
    ItemAction.NON_REGULAR_DELIVERY_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: '定期便から通常商品詳細へ切替',
          events: this.deliveryEvents(['prodView', 'event1', 'event13'], data.isLogin),
          items: window.analyticsData.items,
          club: {
            server: 'club/pc',
            prop5: '定期便から通常商品詳細へ切替',
            events: this.deliveryEvents(['prodView', 'event1', 'event13'], data.isLogin),
            products: window.analyticsData.club.products
          },
          soloel: {
            server: 'soloel/pc',
            prop5: '定期配送から通常商品詳細へ切替',
            events: ['prodView', 'event1', 'event13'],
            products: window.analyticsData.soloel.products
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'chgToNormalProduct');
      });
    });

    /// 大業パまとめ買い設定用数量選択プルダウン押下時
    ItemAction.DISPLAY_PULLDOWN_BULK_PURCHASE_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'まとめ買いプルダウン表示',
          club: {
            server: 'club/pc',
            prop5: 'まとめ買いプルダウン表示',
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'DisplayPulldownBulkPurchase');
      });
    });
  }

  /// items:バリエーション一覧へリンク押下時
  private variationLinkItems(productName: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: {}
    };
  }

  /// events:ログインしている場合は「event8」を追加
  private deliveryEvents(events: Array<string>, isLogin: boolean): Array<string> {
    if (isLogin) {
      events.push('event8');
    }
    return events;
  }

  /// items:通常商品から定期配送に切替を行った場合
  private regularDeliveryItems(items: any, siteType: string) {
    let evars;
    switch (siteType) {
      case 'club':
        evars = this.regularDeliveryClubEvars(items.evars);
        break;
      case 'soloel':
        evars = this.regularDeliverySoloelEvars();
        break;
      default:
        evars = this.regularDeliveryEvars(items.evars);
    }
    return {
      category: '',
      productName: items.productName,
      quantity: '',
      price: '',
      events: [],
      evars: evars
    };
  }

  /// evars:通常商品から定期配送に切替を行った場合
  private regularDeliveryEvars(evars: any) {
    let medicalMaterialType;
    try {
      medicalMaterialType = evars.medicalMaterialType;
    } catch (error) {
      return {
        medicalMaterialType: 'none',
        itemType: 'reg'
      };
    }
    return {
      medicalMaterialType: medicalMaterialType,
      itemType: 'reg'
    };
  }

  /// evars:通常商品から定期配送に切替を行った場合(CLUB)
  private regularDeliveryClubEvars(evars: any) {
    let eVar79;
    try {
      eVar79 = evars.eVar79;
    } catch (error) {
      return {
        eVar79: 'none'
      };
    }
    return {
      eVar79: eVar79
    };
  }

  /// evars:通常商品から定期配送に切替を行った場合(SOLOEL)
  private regularDeliverySoloelEvars() {
    return {
      eVar50: 'reg'
    };
  }
}
